<app-nuevo-tipo [tipos]="tipos"></app-nuevo-tipo>
<mat-card-content class="catalog-list" *ngFor="let tipo of tipos">
  <div *ngIf="admonCatTiposStatus$ | async as tipoStatus">
    <mat-card class="catalog-card">
      <div class="catalog-card-view">
        <p class="catalog-title" style="padding: 1rem">
          {{ tipo?.descripcion }}
        </p>
        <mat-card-actions
          align="end"
          class="nuevo-catalogo-actions"
          *ngIf="!tipoStatus.mostrarEditar && !tipoStatus.mostrarNuevo">
          <button
            class="uppercase-button"
            mat-button
            (click)="editarRegistro(tipo)">
            Editar
          </button>
          <button
            class="uppercase-button"
            mat-button
            (click)="eliminarTipo(tipo)">
            Borrar
          </button>
        </mat-card-actions>
      </div>

      <div
        class="catalog-card-edit !flex"
        *ngIf="tipoStatus.mostrarEditar && tipo == registroSeleccionado">
        <form [formGroup]="editarForm" class="nuevo-catalogo-form !w-1/2">
          <mat-form-field class="nuevo-catalogo-field">
            <mat-label>Descripción</mat-label>
            <input
              formControlName="descripcion"
              name="descripcion"
              class="nuevo-catalogo-input"
              type="text"
              maxlength="50"
              matInput
              [value]="tipo?.descripcion"
              placeholder=""
              (input)="
                existeRegistro(editarForm.get('descripcion'), tipo?.descripcion)
              " />
            <mat-hint align="end"
              >{{ editarForm.get("descripcion")?.value.length }} / 50</mat-hint
            >
            @if ( editarForm.get('descripcion')?.touched && editarForm
            .get('descripcion')?.hasError('campoRequerido')) {
            <mat-error>Campo obligatorio</mat-error>
            } @if ( editarForm.get('descripcion')?.touched &&
            editarForm.get('descripcion')?.hasError('descripcionCatalogo')) {
            <mat-error>Sólo se permiten letras y espacios.</mat-error>
            } @if ( editarForm.get('descripcion')?.touched &&
            editarForm.get('descripcion')?.hasError('descripcionDuplicad@')) {
            <mat-error> La descripción ya se encuentra registrada. </mat-error>
            }
          </mat-form-field>
        </form>
        <mat-card-actions align="end" class="nuevo-catalogo-actions">
          <button
            class="uppercase-button"
            mat-button
            (click)="cancelarEdicion()">
            Cancelar
          </button>
          <button
            class="uppercase-button"
            mat-button
            [disabled]="editarForm.invalid"
            (click)="guardarCambios(tipo)">
            Guardar
          </button>
        </mat-card-actions>
      </div>
    </mat-card>
  </div>
</mat-card-content>
